import {BrowserRouter} from 'react-router-dom'
import AppRoutes from './AppRoutes';


import './styles/bootstrap.scss';
import './styles/app.scss'

import './Vendor.js'

function App() {
  // eslint-disable-next-line no-undef
  const basename = process.env.NODE_ENV === 'development' ? '/' : (process.env.PUBLIC_URL || '/');
  return (
    
    <div className="App">
      <BrowserRouter basename={basename}>
        <AppRoutes/>
      </BrowserRouter>
    </div>
  );
}

export default App;
